/**
 * Debug codes (telemetry, not failures) sent to hp-service POST /log/debug.
 * Pattern: debug.{category}.{specific}
 */
export enum DebugCode {
  /** Vuex state mutated outside a mutation handler (prod soft report; assert stripped in prod). */
  VUEX_ILLEGAL_MUTATION = 'debug.vuex.illegal_mutation',
  /**
   * Vuex mapGetters / store.getters access for a key that is not registered.
   * Vuex only console.errors this when NODE_ENV !== 'production'; prod is silent without our reporter.
   */
  VUEX_UNKNOWN_GETTER = 'debug.vuex.unknown_getter',
  /**
   * store.commit / mapMutations for a type that is not registered.
   * Vuex only console.errors this when NODE_ENV !== 'production'.
   */
  VUEX_UNKNOWN_MUTATION = 'debug.vuex.unknown_mutation',
  /**
   * store.dispatch / mapActions for a type that is not registered.
   * Vuex only console.errors this when NODE_ENV !== 'production'.
   */
  VUEX_UNKNOWN_ACTION = 'debug.vuex.unknown_action',
  /**
   * Vue warn that may indicate a missed @vue/compat MODE 2 breaking fix
   * (soft MODE 2 deprecations like ATTR_FALSE are excluded — they still work under MODE 2).
   */
  VUE_COMPAT_WARNING = 'debug.vue.compat_warning',
}
